import { useEffect, useSyncExternalStore } from 'react';
import { isDarkTheme, THEMES } from './catalog';
import { preferences } from './store';

export function useSharedPreferences() {
  const state = useSyncExternalStore(preferences.subscribe, preferences.getSnapshot, preferences.getSnapshot);
  useEffect(() => {
    const root = document.documentElement;
    root.classList.remove(...THEMES.map(theme => `bcTheme-${theme}`));
    root.classList.add(`bcTheme-${state.theme}`);
    root.style.colorScheme = isDarkTheme(state.theme) ? 'dark' : 'light';
    root.lang = state.language === 'al' ? 'sq' : state.language;
  }, [state]);
  return { ...state, setTheme: preferences.setTheme, setLanguage: preferences.setLanguage };
}
